import React, {FC} from 'react';

import {Text} from './text';

/*
 * Component.
 */

export const Bold: FC = ({children}) => <Text fontWeight="bold">{children}</Text>;
